import { assign, isPlainObject } from 'lodash';

/**
 * @extends VueRouter.RouteConfig
 */
export class BaseRouteConfig {
  constructor(options) {
    assign(this, options);
  }

  /**
   * Not overridable
   *
   * This must be called in routers
   * which must always return the original options, but wrap
   * any required method from VueRouter.RouteConfig
   *
   * @param options
   * @param moduleName
   * @returns {*}
   */
  static factory(options, moduleName) {
    if (isPlainObject(options)) {
      return this._getConfig(options, moduleName);
    }

    options.forEach((option) => {
      this._getConfig(option, moduleName);
    });

    return options;
  }

  /**
   * @param options
   * @param moduleName
   * @returns {*}
   * @private
   */
  static _getConfig(options, moduleName) {
    const pageConfig = new this(options, moduleName);

    options.beforeEnter = (to, from, next) => {
      pageConfig.beforeEnter(to, from, next);
    };

    return options;
  }
}
